const FleetStatus = {
  Active: "active",
  Pending: "pending",
  Expired: "expired",
  Deactivated: "deactivated",
};

export default FleetStatus;
